import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "store/store";

const PageHeader = ({ title }) => {
  const navigate = useNavigate();
  const {auth}=useAuthStore();


  return (
    <HeaderRow>
      <h2>{title}</h2>
       
       {auth.role==='admin'?
        <button className="close-btn" onClick={() => navigate("/AdminDashboard")}>
          ✕
        </button>:
        <button className="close-btn" onClick={() => navigate("/dashboard")}>
          ✕
        </button>
      }
    </HeaderRow>
  );
};

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
 


  h2 {
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.bgd};
    margin: 0;
    }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 2rem;
    font-weight: 500;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.bgd};
    transition: color 0.2s ease;
    padding: 0 1rem;
    }

  .close-btn:hover {
    color: white;
    background: grey;
    }
  
  @media (max-width: ${({ theme }) => theme.media.mobile}){
     
  h2 {
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.bgd};
    margin: 0;
    }

  
  }
`;

export default PageHeader;